import { CouponApiV2 } from '../../../../../lib/api/coupon/CouponApiV2';
import { SearchOption } from '../../../../../types/common/table';
import { CouponItemV2, CouponListRequest, CouponListRequestOption } from '../../../../../types/coupons';
import { checkValidId } from '../../../../../lib/utils/common/checkValideId';

export const couponListFetcher = async (option: SearchOption<CouponListRequest>) => {
  const defaultResult = {
    totalCount: 0,
    coupons: [],
  };

  const result = checkValidId([option.id])
    ? await CouponApiV2.getCouponList(new CouponListRequestOption(option))
    : defaultResult;

  return { totalCount: result.totalCount, list: result.coupons.map((coupon) => new CouponItemV2(coupon)) };
};
